import { Component, ViewChild, OnInit } from '@angular/core';
import { DataSource } from '@angular/cdk/collections';
import { MdPaginator, MdSnackBar, MdDialog, DateAdapter } from "@angular/material";
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import { BrogliaccioDistintaModel } from './../../models/brogliacci/brogliaccio-distinta.model';
import { DistinteIncassiService } from './../../services/distinte-incassi.service';
import { BrogliaccioSearchModel } from "../../models/brogliacci/brogliaccio-search.model";
import { DizionarioModel } from "../../models/shared/dizionario.model";
import { IncassiService } from "../../services/incassi.service";
import { DistinteVersamentiService } from "../../services/distinte-versamenti.service";
import {BancheItemsModel} from "../../models/brogliacci/banche.model";
import { UltimaVersioneApplicativoClientService } from '../../services/ultima-versione-applicativo-client.service';
import { Configurations } from '../../core/configurations';
@Component({
  selector: 'app-distinte-versamenti-list',
  templateUrl: './distinte-versamenti-list.component.html',
  styleUrls: ['./distinte-versamenti-list.component.css']
})



export class DistinteVersamentiListComponent implements OnInit {
  isLoading: boolean;
  displayedColumns = ['id', 'dataCreazione', 'stato', 'totaleValuta', 'totaleAssegni','totale', 'tokenDettagli', 'tokenElimina'];
  dataSource: DistintaVersamentiDataSource | null;
  distintaIncassi: BrogliaccioDistintaModel[];
  model: BrogliaccioSearchModel = null;
  STATI_DISTINTA: DizionarioModel[];
  BANCHE: BancheItemsModel[];
  dataDal?: Date;
  dataAl?: Date;

  constructor(
    private snackBar: MdSnackBar,
    private _distintaService: DistinteVersamentiService,
    private _distintaincassiService: DistinteIncassiService,
    private _dateAdapter: DateAdapter<Date>,
    private _ultimaVersioneClientTipo:UltimaVersioneApplicativoClientService
  ) {

    this._dateAdapter.setLocale('it-IT');
   }


  @ViewChild(MdPaginator) paginator: MdPaginator;
  fixedSum(a:number,b:number,inverse:boolean):number {
    if(!inverse) {
         return Math.round(Math.round((a + b)*1e12)/1e10)/100;
       } else {
         return Math.round(Math.round((a - b)*1e12)/1e10)/100;
       }
   }
  ngOnInit() {
    this._ultimaVersioneClientTipo.getUltimaVersioneApplicativo()
    .subscribe(data => {
      Configurations.currentVersionCod=data.codice;
      let v=localStorage.getItem('clientVersion');
      if(v===null||v===undefined||v!==data.codice) {
        localStorage.setItem('clientVersion',data.codice);
        alert("Sono state pubblicate delle modifiche nel portale, per poterle caricare verrà indirizzato alla homepage.");
        window.location.href=Configurations.baseUrl;
        
      }
    });
    this.model = new BrogliaccioSearchModel();
    let emptyChoice=new DizionarioModel();
    emptyChoice.codice="";
    emptyChoice.descrizione="Tutti";
    this._distintaService.getStati().subscribe(
      data => {
        data.splice(0,0,emptyChoice);
        this.STATI_DISTINTA = data;
      },
      error => {
        this.showError("Errore durante la procedura di caricamento degli stati");
      }
    );
    this._distintaService.getBanche().subscribe(data=> {
      this.BANCHE = data;
    });
    this.isLoading=true;
    //subito quelle aperte
    this.model.idstato=1;
    this.dataSource = new DistintaVersamentiDataSource(this._distintaService, this.paginator, this.model,this);
    
    initDatePicker();
  }

  /* RICERCA */
  search() {

    this.model.dataAl = this.dataAl;
    this.model.dataDal = this.dataDal;
    this.isLoading=true;
    this.dataSource = new DistintaVersamentiDataSource(this._distintaService, this.paginator, this.model,this);
  }

  /* ELIMINAZIONE DI UN DISTINTA */
  eliminaDistintaVersamenti(model: BrogliaccioDistintaModel) {
    //elimino la distinta versamenti(dalla lista)
    this._distintaService.eliminaDistinta(model).subscribe(
      (data: any) => {
        //verifica esito e redirect 
        if (data.result.result === false) {
          this.showError(data.result.message);
          return false;
        } else {
          this.showInfo("Eliminazione avvenuta correttamente");
          this.search();
        }
      },
      error => {
        this.showError("Errore durante la procedura di eliminazione della distinta");
        return false;
      }
    );

  }

  private showError(msg: string) {
    this.snackBar.open(msg, 'Chiudi', { duration: 4000 });
  }

  private showInfo(msg: string) {
    this.snackBar.open(msg, 'Chiudi', { duration: 2000 });
  }
  public getFilteredDistinte(model:DistintaVersamentiDataSource):Observable<BrogliaccioDistintaModel[]> {
    let result=this._distintaService.getFilteredList(this.model);
    result.subscribe(data=> {
      this.isLoading=false;
    });
    return result;
  }

}


/* DATA SOURCE - lista distinta */
export class DistintaVersamentiDataSource extends DataSource<any> {
  constructor(private _distintaService: DistinteVersamentiService, private _paginator: MdPaginator, 
    private model: BrogliaccioSearchModel, private originModel:DistinteVersamentiListComponent) {
    super();
  }
  connect(): Observable<BrogliaccioDistintaModel[]> {
    //return this._distintaService.getFilteredList(this.model);
    return this.originModel.getFilteredDistinte(this);
  }
  disconnect() { }

}




// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/distinteVersamenti/distinte-versamenti-list.component.ts